import { inject, Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { filter, Observable, tap } from 'rxjs';
import { InitialiserDependency } from './init.interface';

@Injectable()
export class PaceAuth0AuthService extends InitialiserDependency {
    private readonly auth = inject(AuthService);

    public ready$ = (): Observable<unknown> =>
        this.auth.isAuthenticated$.pipe(
            tap((authenticated) => {
                if (!authenticated) {
                    this.auth.loginWithRedirect();
                }
            }),
            filter(Boolean),
        );
}
